import { Component, OnInit, forwardRef, Input, TemplateRef, ElementRef, SkipSelf, Host, Optional } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, AbstractControl } from '@angular/forms';
import { Helper } from 'src/app/Helper';
import { MatFormFieldControl } from '@angular/material';

@Component({
  selector: 'searchable-select',
  templateUrl: './searchable-select.component.html',
  styleUrls: ['./searchable-select.component.css'],
  providers: [
   
    { 
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchableSelectComponent),
      multi: true
    }
  ]
})
export class SearchableSelectComponent implements   ControlValueAccessor,OnInit {
  propagateChange:any = () => {};
  @Input('value') _value = 0;
  @Input('options') options = [];
  @Input('optionKey') optionKey = 'id';
  @Input('optionValue') optionValue = 'title';
  @Input('searchValues') searchValues = ['title'];
  @Input() template :TemplateRef<ElementRef>;
  @Input() formControlName: string;
  @Input() label: string="";
  @Input() multiple: boolean=false;
  search="";
  erros:any;
  public control: AbstractControl;
  constructor(
    @Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer,
    public Helper:Helper) { }
  get value() {
    return this._value;
  }
  
  set value(val) {
    this._value = val;
    this.propagateChange(val);
  }
  getErrorMessage() {
    console.log(this.control, this.Helper.validationErrors(this.control))
    return this.Helper.validationErrors(this.control);
  }
  ngOnInit() {
    if (this.controlContainer) {
      if (this.formControlName) {
        this.control = this.controlContainer.control.get(this.formControlName);
        // console.log(this.control.getVa)

        if(this.label==""){
          let lab=this.formControlName.split('_');
          lab=lab.map(v=>{
            return v.charAt(0).toUpperCase() + v.slice(1)
          })
          this.label=lab.join(" ");

        }
      } else {
        console.warn('Missing FormControlName directive from host element of the component');
      }
    } else {
      console.warn('Can\'t find parent FormGroup directive');
    }
  }
  writeValue(value) {
    if (value) {
      this.value = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

}
